module.exports = __webpack_public_path__ + "static/media/fig-toast.182f8a49.jpg";